import { configureStore, Middleware } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { createLogger } from "redux-logger";

import { themeSlice } from "../components/TopNavbar";
import { notificationsSlice } from "../components/Notification";
import { baseApi, errorToastMiddleware } from "../services/api";

const NODE_ENV = import.meta.env.REACT_APP_REACT_ENV;

// Define reducer map
const reducer = {
  notifications: notificationsSlice.reducer,
  theme: themeSlice.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
};

// Create a temporary store to infer types
const tempStore = configureStore({ reducer });

type RootState = ReturnType<typeof tempStore.getState>;
type AppDispatch = typeof tempStore.dispatch;

// Conditionally create and type the logger
let loggerMiddleware: Middleware<{}, RootState, AppDispatch> | undefined =
  undefined;

if (NODE_ENV !== "PRD") {
  loggerMiddleware = createLogger() as Middleware<{}, RootState, AppDispatch>;
}

// Configure the store with the RTK Query api middleware (required for caching,
// invalidation and refetch), the global error-toast middleware, and the
// optional redux logger.
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware().concat(
      errorToastMiddleware,
      baseApi.middleware,
    );
    return loggerMiddleware ? middleware.concat(loggerMiddleware) : middleware;
  },
  devTools: NODE_ENV !== "PRD",
});

// Enables refetchOnFocus / refetchOnReconnect behaviour for RTK Query.
setupListeners(store.dispatch);

export default store;
export type { RootState };
